import { Link } from 'react-router-dom';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { themeClasses } from '@member-portal/ui';

const mediaItems = [
  {
    date: '02.14.2024',
    source: 'PR Newswire',
    title: 'Four Hundred by Design Exceeds 2,000 Travel Advisors and Over 400 Properties Two Years After Launch',
    link: 'https://www.prnewswire.com/news-releases/four-hundred-by-design-exceeds-2-000-travel-advisors-and-over-400-properties-two-years-after-launch-302062159.html',
    image: '/images/media/pr-newswire.jpg',
  },
  {
    date: '10.28.2022',
    source: 'Cision PR Newswire',
    title: 'Four Hundred by Design Celebrates One Year Anniversary with Nearly 1,000 Luxury Travel Advisors',
    link: 'https://www.prnewswire.com/news-releases/four-hundred-by-design-celebrates-one-year-anniversary-with-nearly-1-000-luxury-travel-advisors-301662683.html',
    image: '/images/media/cision-pr-newswire-22-10.jpg',
  },
  {
    date: '07.27.2022',
    source: 'Luxury Travel Advisor',
    title: 'Four Hundred By Design Adds New Luxury Villa Inventory',
    link: 'https://www.luxurytraveladvisor.com/villas-homes/four-hundred-design-adds-new-luxury-villa-inventory-2022',
    image: '/images/media/luxury-travel-advisor.jpg',
  },
  {
    date: '06.11.2022',
    source: 'Travel Weekly',
    title: "'Booking conduit' Four Hundred by Design links advisors to luxe properties",
    link: 'https://www.travelweekly.com/Travel-News/Travel-Agent-Issues/Booking-conduit-Four-Hundred-by-Design-links-advisors-to-luxe-properties',
    image: '/images/media/travel-weekly-booking-conduit.jpg',
  },
  {
    date: '03.03.2022',
    source: 'Insider Travel Report',
    title: 'Insider Video: How Four Hundred by Design Helps Travel Advisors Earn More and Faster',
    link: 'https://www.insidertravelreport.com/insider-video-how-four-hundred-by-design-helps-travel-advisors-earn-more-and-faster-1/',
    image: '/images/media/insider-travel-over-the-top.jpg',
  },
  {
    date: '02.11.2022',
    source: 'Insider Travel Report',
    title: 'New Four Hundred by Design Agency Portal Shares Over-the-Top Hotel Experiences',
    link: 'https://www.insidertravelreport.com/new-four-hundred-by-design-agency-portal-shares-over-the-top-hotel-experiences/',
    image: '/images/media/insider-travel-over-the-top.jpg',
  },
  {
    date: '10.14.2021',
    source: 'Phocuswire',
    title: 'New Booking Platform for Luxury Hotels Promises Higher, Faster Pay',
    link: 'https://www.phocuswire.com/New-booking-platform-for-luxury-hotels-promises-higher-and-faster-pay',
    image: '/images/media/phocuswire-launch.jpg',
  },
  {
    date: '10.11.2021',
    source: 'Travel Weekly',
    title: 'New booking platform for luxury hotels promises higher and faster pay',
    link: 'https://www.travelweekly.com/Travel-News/Travel-Agent-Issues/Four-Hundred-by-Design-launch',
    image: '/images/media/travel-weekly-launch.jpg',
  },
];

function MediaPage() {
  return (
    <div className="fhxd-chrome-top">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/images/rosewood-2.jpg)' }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-title font-normal text-3xl md:text-5xl lg:text-7xl tracking-wider uppercase text-white mb-6">
            Press
          </h1>
          <p className="font-body font-normal leading-relaxed tracking-form text-white/90">
            Four Hundred by Design in the News
          </p>
        </div>
      </section>

      {/* Media Coverage */}
      <section className="py-24 bg-theme-bg">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {mediaItems.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col md:flex-row gap-6 md:gap-8 pb-12 border-b border-theme-border last:border-0"
              >
                {/* Image */}
                <div className="w-full md:w-72 flex-shrink-0 overflow-hidden bg-theme-bg-secondary">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-auto object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                {/* Content */}
                <div className="flex-1">
                  <p className={`${themeClasses.text.caption} mb-3`}>
                    {item.source}
                  </p>
                  <h3 className={`${themeClasses.title.h5} ${themeClasses.colors.hover.text} transition-colors duration-300 flex items-start gap-3`}>
                    <span>{item.title}</span>
                    <ArrowTopRightOnSquareIcon className="h-5 w-5 flex-shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-theme-bg-secondary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className={`${themeClasses.title.h3} mb-6`}>
            READY TO GET STARTED?
          </h2>
          <p className={`${themeClasses.text.body} mb-8`}>
            Discover the FHxD world-class travel partner collection and earn more, faster.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/signup"
              className={themeClasses.button.primary}
            >
              Advisor Sign Up
            </Link>
            <Link
              to="/about"
              className={themeClasses.button.secondary}
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MediaPage;
